// Travel intelligence data: moods, stories, trending — drives Faza A discovery features.

export const TRAVEL_MOODS = [
  { id: 'luxury',       label: 'Luxury',         emoji: '💎', color: '#9333EA', desc: 'Five-star stays, fine dining, spa retreats' },
  { id: 'hidden-gems',  label: 'Hidden Gems',    emoji: '🗝️', color: '#0EA5E9', desc: 'Off-the-map places only locals know' },
  { id: 'romantic',     label: 'Romantic',       emoji: '💕', color: '#EC4899', desc: 'Sunset terraces, candlelit dinners, boutique escapes' },
  { id: 'foodie',       label: 'Foodie',         emoji: '🍴', color: '#F59E0B', desc: 'Chef tables, street food, wine routes' },
  { id: 'adventure',    label: 'Adventure',      emoji: '🏔️', color: '#10B981', desc: 'Hiking, rafting, canyoning, mountains' },
  { id: 'nightlife',    label: 'Nightlife',      emoji: '🎵', color: '#6366F1', desc: 'Rooftop bars, beach clubs, live music' },
  { id: 'family',       label: 'Family',         emoji: '👨‍👩‍👧', color: '#0891B2', desc: 'Kid-friendly beaches, parks & resorts' },
  { id: 'digital-nomad',label: 'Digital Nomad',  emoji: '💻', color: '#475569', desc: 'Fast WiFi cafes, coworking, long-stay flats' },
  { id: 'sunset',       label: 'Sunset Chasers', emoji: '🌅', color: '#F97316', desc: 'Best golden-hour spots and viewpoints' },
  { id: 'authentic',    label: 'Authentic',      emoji: '🇦🇱', color: '#DC2626', desc: 'Traditional villages, UNESCO sites, real culture' },
  { id: 'beach',        label: 'Beach',          emoji: '🏖️', color: '#06B6D4', desc: 'Crystal water, beach clubs, hidden coves' },
  { id: 'wellness',     label: 'Wellness',       emoji: '🧘', color: '#84CC16', desc: 'Spas, hot springs, yoga retreats' },
];

// Map businesses to moods (extends mockData.BUSINESSES)
export const BUSINESS_MOODS = {
  'b-al-1': ['luxury', 'romantic', 'beach', 'sunset'],
  'b-al-2': ['nightlife', 'beach', 'sunset'],
  'b-al-3': ['authentic', 'hidden-gems'],
  'b-al-4': ['foodie', 'authentic'],
  'b-al-5': ['hidden-gems', 'authentic'],
  'b-al-6': ['family', 'beach'],
  'b-al-7': ['foodie', 'luxury'],
  'b-al-8': ['romantic', 'sunset', 'foodie'],
  'b-al-9': ['authentic', 'hidden-gems'],
  'b-ks-1': ['luxury', 'romantic'],
  'b-ks-2': ['digital-nomad', 'foodie'],
  'b-ks-3': ['authentic', 'hidden-gems'],
  'b-ks-4': ['adventure', 'luxury', 'hidden-gems'],
  'b-ks-5': ['digital-nomad', 'foodie'],
  'b-ks-6': ['authentic', 'hidden-gems'],
  'b-mk-1': ['romantic', 'sunset', 'foodie'],
  'b-mk-2': ['adventure', 'hidden-gems'],
  'b-mk-3': ['luxury', 'romantic'],
  'b-mk-4': ['authentic'],
  'b-mk-5': ['foodie', 'digital-nomad'],
  'b-mk-6': ['adventure', 'wellness', 'family'],
  'b-3vf-durresit':  ['authentic', 'digital-nomad'],
  'b-3vf-barrikadave':['authentic', 'digital-nomad'],
  'b-3vf-kavajes':   ['authentic', 'digital-nomad'],
  // Whisky Group — premium featured listings
  'b-whisky-tirana':     ['nightlife', 'luxury', 'romantic', 'foodie'],
  'b-whisky-greencoast': ['beach', 'nightlife', 'luxury', 'sunset', 'foodie', 'romantic'],
};

// Trending now — refreshed weekly editorially
export const TRENDING = [
  { businessId: 'b-whisky-tirana',     trend: 'Most reserved',  tag: 'Premium nightlife',  country: 'albania' },
  { businessId: 'b-whisky-greencoast', trend: 'Viral on TikTok', tag: 'Riviera beach club', country: 'albania' },
  { businessId: 'b-3vf-durresit', trend: 'Featured brand', tag: 'Premium mobile shop', country: 'albania' },
  { businessId: 'b-al-1', trend: '+312% saves', tag: 'Trending tonight', country: 'albania' },
  { businessId: 'b-al-9', trend: 'Viral on TikTok', tag: 'Most reels this week', country: 'albania' },
  { businessId: 'b-al-7', trend: 'Top reservations', tag: 'Hot table this week', country: 'albania' },
  { businessId: 'b-mk-2', trend: 'Newly added', tag: "Editor's pick", country: 'north-macedonia' },
  { businessId: 'b-ks-4', trend: '+180% saves', tag: 'Trending', country: 'kosovo' },
  { businessId: 'b-al-8', trend: 'Top sunset spot', tag: 'Sunset hour', country: 'albania' },
];

// Travel stories — cinematic editorial content (creator-style)
export const TRAVEL_STORIES = [
  {
    slug: '48-hours-in-himare',
    title: '48 hours in Himarë',
    subtitle: 'A long weekend that feels like a week',
    country: 'albania',
    city: 'saranda',
    author: 'InfoPoint Editors',
    cover: 'https://images.unsplash.com/photo-1742244002755-067b34f9f1c6',
    readTime: '7 min',
    publishedAt: '2026-02-12',
    moods: ['hidden-gems', 'romantic', 'beach', 'sunset'],
    excerpt: 'Tucked between Sarandë and Vlorë, Himarë is the Riviera secret your friends are about to ruin. Here\'s how to do it before they do.',
    chapters: [
      { time: 'Day 1 · Morning', title: 'Arrive & breathe', body: 'Drop your bags at a boutique seafront stay. Walk down to Llamani beach, grab a Greek-style coffee, and let the sea wake you up.', businessIds: ['b-al-1'] },
      { time: 'Day 1 · Afternoon', title: 'Hidden cove hunt', body: 'Rent a kayak and paddle 15 minutes south to Filikuri — a chapel-and-beach combo most tourists never find.', businessIds: ['b-al-2'] },
      { time: 'Day 1 · Sunset', title: 'The sunset table', body: 'Climb to a hilltop castle restaurant and order the grilled octopus. The light at 19:30 is the reason you came.', businessIds: ['b-al-8'] },
      { time: 'Day 2 · Morning', title: 'Boat to the coves', body: 'Charter a small wooden boat from the harbor. Stop at Gjipe canyon for breakfast on the sand.', businessIds: ['b-al-2'] },
      { time: 'Day 2 · Late afternoon', title: 'Slow farewell', body: 'Long lunch with the local seafood, swim until the light goes soft, then drive north along SH8 — every curve is a postcard.', businessIds: ['b-al-7'] },
    ],
  },
  {
    slug: 'best-albania-sunsets',
    title: '7 Best Albania sunsets',
    subtitle: 'Where to chase the golden hour',
    country: 'albania',
    author: 'InfoPoint Editors',
    cover: 'https://images.pexels.com/photos/33945650/pexels-photo-33945650.jpeg',
    readTime: '5 min',
    publishedAt: '2026-02-08',
    moods: ['sunset', 'romantic', 'hidden-gems'],
    excerpt: 'From mountain monasteries to Riviera rooftops — these seven spots make the rest of the world look gray.',
    chapters: [
      { time: '1', title: 'Lëkurësi Castle, Sarandë', body: 'A 13th-century fortress turned restaurant. The sun sets directly into the Ionian — book the corner table.', businessIds: ['b-al-8'] },
      { time: '2', title: 'Ksamil beach bars', body: 'The Albanian "Maldives" — the three islets glow pink at golden hour.', businessIds: ['b-al-1', 'b-al-2'] },
      { time: '3', title: 'Berat castle', body: 'A thousand windows lighting up one by one. Bring wine.', businessIds: ['b-al-9'] },
    ],
  },
  {
    slug: 'hidden-kosovo',
    title: 'Hidden Kosovo: 3 days off the radar',
    subtitle: 'The Balkans you didn\'t know existed',
    country: 'kosovo',
    author: 'InfoPoint Editors',
    cover: 'https://images.pexels.com/photos/33092891/pexels-photo-33092891.jpeg',
    readTime: '8 min',
    publishedAt: '2026-02-05',
    moods: ['hidden-gems', 'adventure', 'authentic'],
    excerpt: 'Europe\'s youngest country is also its most underrated. Three days, two cities, one canyon you\'ll never forget.',
    chapters: [
      { time: 'Day 1', title: 'Prizren\'s old soul', body: 'Cobblestones, mosques, a river running through the middle. Stay at a boutique inside the bazaar.', businessIds: ['b-ks-1', 'b-ks-3'] },
      { time: 'Day 2', title: 'Pristina café tour', body: 'Europe\'s most caffeine-fueled capital. We mapped the 5 cafés worth your morning.', businessIds: ['b-ks-2', 'b-ks-5'] },
      { time: 'Day 3', title: 'Rugova canyon', body: 'Zip-lines, alpine air and a lodge where the wifi is bad and the views are perfect.', businessIds: ['b-ks-4'] },
    ],
  },
  {
    slug: 'ohrid-weekend',
    title: 'Ohrid: lake, monasteries, midnight cherries',
    subtitle: 'A spiritual 2 days in North Macedonia',
    country: 'north-macedonia',
    city: 'ohrid',
    author: 'InfoPoint Editors',
    cover: 'https://images.unsplash.com/photo-1537113799915-0a24165b3f72',
    readTime: '6 min',
    publishedAt: '2026-02-01',
    moods: ['romantic', 'authentic', 'wellness', 'sunset'],
    excerpt: '365 churches, one impossibly blue lake. Why Ohrid will quietly become your favorite place in the Balkans.',
    chapters: [
      { time: 'Day 1', title: 'Lakeside slow living', body: 'Boat to the monastery at Kaneo, lunch on a wooden pier, espresso in the old town.', businessIds: ['b-mk-1', 'b-mk-3'] },
      { time: 'Day 2', title: 'Skopje detour', body: 'Hop to Skopje for the bazaar and Matka canyon — back to Ohrid for sunset.', businessIds: ['b-mk-2', 'b-mk-4'] },
    ],
  },
];

// Event mockups for "Tonight in Tirana / Sarandë / Pristina"
export const EVENTS = [
  { id: 'e1', title: 'Live jazz at Mullixhiu',        city: 'tirana',     country: 'albania', date: 'Tonight',  time: '21:00', type: 'Live music', businessId: 'b-al-7' },
  { id: 'e2', title: 'Sunset DJ set · Ksamil',         city: 'ksamil',     country: 'albania', date: 'Tomorrow', time: '19:30', type: 'Beach club', businessId: 'b-al-2' },
  { id: 'e3', title: 'Wine tasting · Berat',           city: 'berat',      country: 'albania', date: 'Saturday', time: '18:00', type: 'Tasting',    businessId: 'b-al-9' },
  { id: 'e4', title: 'Acoustic night · Liburnia',      city: 'pristina',   country: 'kosovo',  date: 'Tonight',  time: '20:30', type: 'Live music', businessId: 'b-ks-2' },
  { id: 'e5', title: 'Boat trip · Matka canyon',       city: 'skopje',     country: 'north-macedonia', date: 'Tomorrow', time: '10:00', type: 'Activity', businessId: 'b-mk-2' },
  { id: 'e6', title: 'Lake sunset cruise · Ohrid',     city: 'ohrid',      country: 'north-macedonia', date: 'Tonight', time: '19:00', type: 'Cruise', businessId: 'b-mk-1' },
];

// Live offers/deals — businesses post today specials
export const OFFERS = [
  { id: 'o1', businessId: 'b-al-1', label: '20% off rooftop suite',    expires: 'Tonight',  badge: 'Hot deal' },
  { id: 'o2', businessId: 'b-al-2', label: '2 cocktails sunset hour',  expires: '18:00-20:00', badge: 'Happy hour' },
  { id: 'o3', businessId: 'b-al-8', label: 'Free wine with seafood',   expires: 'Sat-Sun',  badge: 'Weekend' },
  { id: 'o4', businessId: 'b-ks-4', label: 'Free hike guide',          expires: 'This week', badge: 'Adventure' },
  { id: 'o5', businessId: 'b-mk-3', label: '15% off 2-night stay',     expires: 'Aug',       badge: 'Long stay' },
];
